export default {
    logPrefix: 'Noisy May',
}



// WEBPACK FOOTER //
// ./config.js